class QuickViewModal extends HTMLElement {
  constructor() {
    super();

    const observe = new MutationObserver((mutationsList, observer) => {
      // Use traditional 'for loops' for IE 11
      for(const mutation of mutationsList) {
        if (mutation.type === 'attributes' && this.getAttribute('aria-hidden') == 'false') {
          setTimeout(() => {
            this.init();
          }, 100);
        }
      }
    });
    observe.observe(this, { attributes: true });
  }

  init() {
    this.initFlickity();

    this.quantityLabel = this.querySelector(
      ".QuantitySelector__CurrentQuantity"
    );
    const decreaseButton = this.querySelector(
      ".QuantitySelector__Button[data-action='decrease-quantity']"
    );
    const increaseButton = this.querySelector(
      ".QuantitySelector__Button[data-action='increase-quantity']"
    );

    decreaseButton.addEventListener("click", this.decreaseQuantity.bind(this));
    increaseButton.addEventListener("click", this.increaseQuantity.bind(this));

    this.querySelector(".ProductForm__AddToCart").addEventListener(
      "click",
      this.addToCart.bind(this)
    );
  }

  addToCart() {
    const variantId = parseInt(
      this.querySelector(".quick-view__variant-id").value
    );
    const quantity = parseInt(this.quantityLabel.value);
    let formData = {
      items: [
        {
          id: variantId,
          quantity: quantity,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(() => {
        this.setAttribute("aria-hidden", "true");
        this.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: variantId,
              quantity: quantity,
            },
          })
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  decreaseQuantity() {
    this.quantityLabel.value = Math.max(
      parseInt(this.quantityLabel.value) - 1,
      1
    );
  }

  increaseQuantity() {
    this.quantityLabel.value = parseInt(this.quantityLabel.value) + 1;
  }

  initFlickity() {
    $(`.quick-view__slider`).flickity({
      contain: true,
      prevNextButtons: false,
      pageDots: false,
    });

    $(`.quick-view__gallery-thumbnail`).flickity({
      percentPosition: false,
      groupCells: "100%",
      pageDots: false,
      prevNextButtons: false,
      asNavFor: `.quick-view__slider`
    });
  }
}

customElements.define("quick-view-modal", QuickViewModal);

class AddToCart extends HTMLElement {
  constructor() {
    super();

    const atcButton = this.querySelector(".ProductItem__atc");
    if (atcButton) {
      atcButton.addEventListener("click", this.addToCart.bind(this));
    }

    const emailMeButton = this.querySelector(".ProductItem__email-me-button");
    if (emailMeButton) {
      emailMeButton.addEventListener("click", this.navigateToPDP.bind(this));
    }

    const quickView = this.querySelector('.ProductItem__qv');
    const productInfo = this.querySelector('[data-product-info]');
    if (productInfo) {
      this.product = JSON.parse(productInfo.textContent);
    }
    if (quickView) {
      quickView.addEventListener("click", this.openQuickViewModal.bind(this) );
    }

    const productMetafield = this.querySelector('[data-product-metafields]');
    if (productMetafield) {
      this.productMetafield = JSON.parse(productMetafield.textContent);
    }

    const selectedVariant = this.querySelector('[data-selected-variant]');
    if (selectedVariant) {
      this.selectedVariant = JSON.parse(selectedVariant.textContent);
    }
    
    const productText = this.querySelector('[data-product-text]');
    if (productText) {
      this.productText = JSON.parse(productText.textContent);
    }

    const productImages = this.querySelector('[data-product-images]');
    if (productImages) {
      this.productImages = JSON.parse(productImages.textContent);
    }
  }

  navigateToPDP() {
    const product_url = this.querySelector(".add-to-cart__product-url").value;
    window.location.href = product_url + "?open-bis-modal";
  }

  addToCart() {
    const variantId = parseInt(
      this.querySelector(".add-to-cart__variant-id").value
    );

    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(() => {
        this.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: variantId,
              quantity: 1,
            },
          })
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  openQuickViewModal() {
    const quickViewModal = document.getElementById('modal-quick-view');

    if (quickViewModal) {
      let thumbnailImages = '';
      let sliderImages = '';
      this.productImages.forEach(image => {
        thumbnailImages += `<img src="${image}" alt="quick view thumbnail image" class="quick-view__thumbnail-image Image--lazyLoad">`;
        sliderImages += `<img src="${image}" alt="quick view slider image" class="quick-view__slider-image Image--lazyLoad">`;
      });

      const $thumbnail = $('.quick-view__gallery-thumbnail');
      const $slider = $('.quick-view__slider');
      $thumbnail.flickity('destroy');
      $slider.flickity('destroy');


      $thumbnail.html(thumbnailImages);
      $slider.html(sliderImages);

      $('.quick-view__product-title').text(`${this.product.title}`);
      $('.quick-view__product-price').text(`${this.product.price}`);

      if (this.product.tags.includes('preorder') && this.selectedVariant.inventory_quantity == 0) {
        $('.ProductMeta__estimate-date-dom').html(`<div class="ProductMeta__estimate-date">Estimated ship date ${this.productMetafield.estimate_date} </div>`)
      } else {
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let today = new Date();
        const startDate = new Date(today.setDate(today.getDate() + 4));

        today = new Date();
        const endDate = new Date(today.setDate(today.getDate() + 11));

        let message = "Estimated Delivery ";
        if (startDate.getMonth() == endDate.getMonth()) {
          message += `${monthNames[startDate.getMonth()]} ${startDate.getDate()} - ${endDate.getDate()}`;
        } else {
          message += `${monthNames[startDate.getMonth()]} ${startDate.getDate()} - ${monthNames[endDate.getMonth()]} ${endDate.getDate()}`;
        }
        $('.ProductMeta__estimate-date-dom').html(`<div class="ProductMeta__estimate-date">${message}</div>`);
      }

      $('.quick-view__variant-id').val(this.selectedVariant.id);
      let atcDOM = '';
      atcDOM += `<button type="submit" class="ProductForm__AddToCart Button Button--primary Button--full" ${ this.selectedVariant.available ? 'data-action="add-to-cart"' : 'disabled="disabled"' }>`;
      if (this.selectedVariant.available) {
        atcDOM += '<span>';
        if (this.product.tags.includes('preorder') && this.selectedVariant.inventory_quantity == 0 ) {
          atcDOM += this.productText.pre_order;
        } else {
          atcDOM += this.productText.add_to_cart;
        }
        atcDOM += '</span>';

        atcDOM += `
          <span class="Button__SeparatorDot"></span>
          <span data-money-convertible>${this.selectedVariant.price}</span>
        `
      } else {
        atcDOM += this.productText.sold_out;
        if (this.productMetafield.back_in_stock_date != null) {
          atcDOM += `<span class="Button__SeparatorDot"></span> Back in stock ${this.productMetafield.back_in_stock_date}`;
        }
      }
      $('.ProductForm__Button-dom').html(atcDOM);

      $(".quick-view__view-details-cta").attr("href", this.product.url);
    }
  }
}

customElements.define("add-to-cart", AddToCart);
